import { atom } from 'jotai';
import { getProductCategories } from '@/api/product';

export interface ProductCategory {
  categoryId: number;
  categoryTitle: string;
  productCategoryId: number;
}

// 创建原子状态
export const productCategoriesAtom = atom<ProductCategory[]>([]);

// 创建一个加载数据的函数
export const loadProductCategories = async (
  set: (value: ProductCategory[]) => void
) => {
  try {
    const data = await getProductCategories(1);
    set(data.data || []);
  } catch (error) {
    console.error('Failed to load product categories:', error);
  }
};
